<template>
  <div class="home">
	<Loading v-if="!loadingDone"/>
    <!-- 引入同步导航组件 -->
    <div class="main-content-top">
      <van-swipe class="swipe-top" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in banner" :key="index"><img :src="item.images" alt="" @click="bannerLink(item.type,item.url)"></van-swipe-item>
      </van-swipe>
      <!-- 引入搜索框组件 -->
      <SearchBox/>
    </div>
    <div class="recommend-box">
      <ColumnTitle :msg="['推荐剧本',false]"/>
        <div class="recommend-swipe-box">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item,index) in recommend" :key="index">
              <router-link :to="{name:'scriptdetail',query:{id:item&&item.id,type:item&&item.type}}">
                <div class="recommend-list">
                  <div class="img"><img :src="item&&item.image" alt=""></div>
                  <div class="info">
                    <p class="info-title">{{item&&item.title}}</p>
                    <p class="info-intro">{{item&&item.intro}}</p>
                  </div>
                </div>
              </router-link> 
            </swiper-slide>
          </swiper>
        </div>
    </div>
    <div class="main-content-middle">
      <ColumnTitle :msg="['专业中文剧本库',true]"/>
      <ul class="teleplay-list">
        <li v-for="(item,index) in tvplay" :key="index">
          <router-link :to="{name:'scriptdetail',query:{id:item&&item.id,type:item&&item.type}}">
            <p class="title-status"><span class="title">{{item&&item.title}}</span><span class="status" :style="item.over===1?'background:#bf0000':'background:#282828'">{{item&&item.over===1?"已完结":"未完结"}}</span></p>
            <p class="describe">{{item&&item.yijuhua}}</p>
            <div class="img-intro">
              <figure class="img">
                <img :src="item&&item.image" alt="">
              </figure>
              <div class="intro">
                {{item&&item.intro}}
              </div>
            </div>
            <p class="author-tag"><span class="author">编剧：{{item&&item.writer_name}}</span><span class="tag">{{item&&item.two_cateid_name.slice(0,2).join('·')}}</span></p>
          </router-link>
        </li>
      </ul>
      <ColumnTitle :msg="['电影',true]"/>
      <ul class="film-list">
        <li v-for="(item,index) in film" :key="index">
          <router-link :to="{name:'scriptdetail',query:{id:item&&item.id,type:item&&item.type}}">
          <figure class="img">
            <img :src="item&&item.image" alt="">
          </figure>
          <div class="film-info">
            <p class="title-status"><span class="title">{{item&&item.title}}</span><span class="status" :style="item.over===1?'background:#bf0000':'background:#282828'">{{item&&item.over===1?"已完结":"未完结"}}</span></p>
            <p class="author">{{item&&item.writer_name}}</p>
            <p class="intro">{{item&&item.intro}}</p>
            <p class="tag">{{item&&item.two_cateid_name.join('·')}}</p>
          </div>
          </router-link>
        </li>
      </ul>
      <ColumnTitle :msg="['排行榜',false]"/>
      <ul class="rank-list">
        <li>
          <router-link :to="{name:'scriptdetail',query:{id:rankTop3.length&&rankTop3[0].id,type:rankTop3.length&&rankTop3[0].type}}">
            <span class="order order-first"></span>
            <div class="title-type"><span class="title">{{rankTop3.length&&rankTop3[0].title}}</span><span class="type">{{rankTop3.length&&rankTop3[0].one_cateid_name}}</span></div>
          </router-link>
        </li>
        <li>
          <router-link :to="{name:'scriptdetail',query:{id:rankTop3.length&&rankTop3[1].id,type:rankTop3.length&&rankTop3[1].type}}">
            <span class="order order-second"></span>
            <div class="title-type"><span class="title">{{rankTop3.length&&rankTop3[1].title}}</span><span class="type">{{rankTop3.length&&rankTop3[1].one_cateid_name}}</span></div>
          </router-link>
        </li>
        <li>
          <router-link :to="{name:'scriptdetail',query:{id:rankTop3.length&&rankTop3[2].id,type:rankTop3.length&&rankTop3[2].type}}">
            <span class="order order-third"></span>
            <div class="title-type"><span class="title">{{rankTop3.length&&rankTop3[2].title}}</span><span class="type">{{rankTop3.length&&rankTop3[2].one_cateid_name}}</span></div>
          </router-link>        
        </li>
        <li v-for="(item,index) in rankLast" :key="index">
          <router-link :to="{name:'scriptdetail',query:{id:item&&item.id,type:item&&item.type}}">
            <span class="order">{{index+4}}</span>
            <div class="title-type"><span class="title">{{item&&item.title}}</span><span class="type">{{item&&item.one_cateid_name}}</span></div>
          </router-link>
        </li>
      </ul>
      <ColumnTitle :msg="['成功案例',false]"/>
      <ul class="success-case">
        <li v-for="(item,index) in succase" :key="index">
          <router-link :to="{name:'success',query:{id:item&&item.id}}">
            <figure>
              <img :src="item&&item.record_image" alt="">
            </figure>
            <h3>{{item&&item.record_title}}</h3>
            <p class="intro">{{item&&item.record_desc}}</p>
          </router-link>
        </li>
      </ul>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading.vue'
import SearchBox from '@/components/SearchBox.vue'
import ColumnTitle from '@/components/ColumnTitle.vue'
import Footer from '@/components/Footer.vue'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {GetCookie} from '@/assets/api/cookie'
export default {
  name: 'Home',
  data(){
    return{
      banner:[],                    //首页banner图数据
      recommend:[],                 //首页推荐剧本数据
      tvplay:[],                    //首页电视剧数据
      film:[],                      //首页电影数据
      rankTop3:[],                  //首页排行榜数据前三
      rankLast:[],                  //首页排行榜后七
      succase:[],                   //首页成功案例数据
      swiperOption: {               //推荐位轮播配置
        slidesPerView: 'auto',
        spaceBetween: 30,
	  },
	  loadingDone:false
    }
  },
  created(){
	  //获取首页banner
	  Axios.get('banner/index').then(
		  response=>{
			  if(response.data.code==200&&response.data.status=="success"){
				  this.setBannerData(response.data.data)
			  }
		  }
	  )
	  //获取首页模块数据
	  Axios.get('module/index').then(
		  response=>{
			  if(response.data.code==200&&response.data.status=="success"){
				  this.moduleData(response.data.data)
				  this.loadingDone=true
			  }
		  }
	  )
  },
  methods:{
    //控制首页图片点击跳转
    bannerLink(type,url){
      if(type===0){
        return false
      }else{
        location.href=url
      }
    },
    //处理首页BANNER图数据
    setBannerData(res){
      this.banner=res
    },
    //处理首页其他剧本展示数据
    moduleData(res){
      this.recommend=res.tuijian
      this.tvplay=res.dianshiju
	  this.film=res.dianying
      this.rankTop3=res.paihang.slice(0,3)
      this.rankLast=res.paihang.slice(3)
      this.succase=res.chenggonganli
    }
  },
  components: {
    SearchBox,
    ColumnTitle,
    Footer,
    swiper,
	swiperSlide,
	Loading
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.home{
  width:750px;
  height:100%;
  background:#f8f6f7;
  padding-top:88px;
}
//头部轮播图样式开始
.swipe-top{
  .van-swipe-item{
    color: #fff;
    width:750px !important;
    height:300px !important;
    line-height:300px;
    font-size:30px;
    text-align:center;
    background-color: #39a9ed;
    float:left;
    img{
      width:100%;
      height:100%;
    }
  }
}
.van-swipe__indicators{
  bottom:60px !important;
  i{
    width:12px;
    height:12px;
  }
}
//头部轮播图样式结束

//推荐剧本轮播图样式开始
.swipe-middle{
  height:310px;
  overflow:hidden;
}
//推荐剧本轮播图样式结束

.main-content-top{
  height:340px;
  position:relative;
  background:#fff;
}
.recommend-box{
  padding-bottom:36px;
  background:#fff;
  overflow:hidden;
  width:750px;
  .recommend-swipe-box{
    width:730px;
    margin-left:20px;
    .swiper-wrapper{
      padding-top:6px;
    }
    .swiper-slide {
      width:600px !important;
      height:280px;
      margin-bottom:12px;
      background:#fff;
      box-shadow:0px 0px 6px #ccc;
    }
    .swiper-slide:nth-child(2n) {
      width:600px !important;
    }
    .swiper-slide:nth-child(3n) {
      width:600px !important;
    }
    .recommend-list{
      width:600px;
      position:relative;
      .img{
        width:196px;
        height:280px;
        background:#ccc;
        position:absolute;
        left:0;
        top:0;
        img{
          width:100%;
          height:100%;
        }
      }
      .info{
        width:360px;
        height:180px;
        position:absolute;
        right:0;
        top:0;
        padding:50px 22px;
        .info-title{
          font-size:30px;
          color:#222;
          height:30px;
          font-weight:bold;
          margin-bottom:32px;
        }
        .info-intro{
          text-align:left;
          height:106px;
          font-size:24px;
          color:#999;
          line-height:38px;
          overflow:hidden;
          display:-webkit-box;
          -webkit-line-clamp:3;
          -webkit-box-orient:vertical;
          text-overflow:ellipsis;
        }
      }
    }
  }
}
.main-content-middle{
  //padding:36px 24px;
  // 首页电视剧剧本样式开始
  .teleplay-list{
    li:first-child{
      padding-top:20px;
    }
    li{
      padding:40px;
      background:#fff;
      margin-bottom:10px;
      a{
        overflow:hidden;
      }
      .title-status{
        height:36px;
        margin-bottom:22px;
        position:relative;
        .title,.status{
          position:absolute;
          top:0;
          display:inline-block;
        }
        .title{
          font-size:30px;
          color:#222;
          left:0;
          top:1px;
        }
        .status{
          display:inline-block;
          width:76px;
          padding:6px 0;
          background:#282828;
          text-align:center;
          font-size:20px;
          color:#f7f7f7;
          right:0;
          top:-2px;
        }
      }
      .describe{
        font-size:24px;
        color:#222;
        text-align:left;
        margin-bottom:28px;
      }
      .img-intro{
        height:150px;
        overflow:hidden;
        margin-bottom:40px;
        .img{
          width:108px;
          height:150px;
          float:left;
          margin-right:20px;
          img{
            width:100%;
          }
        }
        .intro{
          text-align:left;
          color:#999;
          font-size:24px;
          line-height:38px;
          display: -webkit-box;
          line-height: 1.6;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .author-tag{
        height:24px;
        overflow:hidden;
        .author,.tag{
          height:24px;
          line-height:24px;
          color:#999;
          font-size:24px;
        }
        .author{
          float:left;
        }
        .tag{
          float:right;
        }
      }
    }
  }
  // 首页电视剧剧本样式结束

  // 首页电影剧本样式开始
  .film-list{
    li:first-child{
      padding-top:20px;
    }
    li{
      height:284px;
      padding:40px;
      background:#fff;
      margin-bottom:10px;
      background:#fff;
      overflow:hidden;
      .img{
        width:194px;
        height:280px;
        float:left;
        margin-right:18px;
        img{
          width:100%;
        }
      }
      .film-info{
        width:456px;
        height:280px;
        float:left;
      }
    }
    .film-info{
      .title-status{
        height:30px;
        margin-bottom:22px;
        position:relative;
        .title,.status{
          display:inline-block;
          position:absolute;
          top:0;
        }
        .title{
          font-size:30px;
          color:#222;
          left:0;
        }
        .status{
          display:inline-block;
          width:76px;
          padding:6px 0;
          text-align:center;
          background:#282828;
          color:#f7f7f7;
          font-size:20px;
          vertical-align:top;
          right:0;
          top:-2px;
        }
      }
      .author{
        text-align:left;
        height:24px;
        line-height:24px;
        font-size:24px;
        color:#222;
        margin-bottom:22px;
      }
      .intro{
        height:110px;
        margin-bottom:48px;
        font-size:24px;
        display: -webkit-box;
        line-height: 1.6;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .intro,.tag{
        color:#999;
        font-size:24px;
        text-align:left;
      }
    }
  }
  // 首页电影剧本样式结束

  //首页排行榜样式开始
  .rank-list{
    padding-bottom:20px;
    overflow:hidden;
    background:#fff;
    li{
      position:relative;
      height:90px;
      background:#fff;
      a{
        width:100%;
        height:100%;
        position:absolute;
        left:0;
        top:0;
        z-index:99;
      }
      .order{
        display:inline-block;
        width:21px;
        height:24px;
        line-height:24px;
        position:absolute;
        left:40px;
        top:30px;
        color:#ccc;
        font-size:20px;
      }
      .order-first{
        background:url('../assets/img/rank1.png') no-repeat;
        background-size:cover;
      }
      .order-second{
        background:url('../assets/img/rank2.png') no-repeat;
        background-size:cover;
      }
      .order-third{
        background:url('../assets/img/rank3.png') no-repeat;
        background-size:cover;
      }
      .title-type{
        position:absolute;
        right:40px;
        top:0;
        height:25px;
        padding:30px 0;
        border-bottom:1px dotted #E6E6E6;
        width:620px;
        .title{
          float:left;
          font-size:24px;
          color:#333;
        }
        .type{
          float:right;
          font-size:24px;
          color:#999;
        }
      }
    }
  }
  //首页排行榜样式结束
  //首页成功案例样式开始
  .success-case{
    li:first-child{
      padding-top:20px;
    }
    li{
      padding:40px 0;
      margin-bottom:10px;
      background:#fff;
      figure{
        width:675px;
        height:120px;
        margin:0 auto;
        margin-bottom:30px;
        img{
          height:100%;
          width:100%;
        }
      }
      h3{
        width:675px;
        margin:0 auto;
        font-size:30px;
        color:#222;
        text-align:left;
        height:28px;
        line-height:28px;
        margin-bottom:20px;
      }
      .intro{
        width:675px;
        margin:0 auto;
        text-align:left;
        font-size:24px;
        color:#999;
        height:110px;
        display: -webkit-box;
        line-height: 1.6;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
